import { useStatsigClient } from "@statsig/react-bindings";

import { useTranslation } from "@flare/i18n";
import { Text } from "@flare/ui/components";
import { cn } from "@flare/ui/utils";

import { featureFlagNames } from "@/services/experiments/constants";

export function Footer({ className }: { className?: string }) {
  const { t } = useTranslation();
  const { getExperiment } = useStatsigClient();

  const abcTest = getExperiment(
    featureFlagNames.funnel_test_questions_buttons_feedback,
  );

  const isButtonsTestOn =
    abcTest.get("groupSymbol") === "new_questions_and_buttons";

  return (
    <footer
      className={cn(
        "border-t border-primary bg-surface md:h-auto",
        {
          "h-[208px] md:h-auto": !isButtonsTestOn,
        },
        className,
      )}
    >
      <div className="m-auto max-w-[1054px] ">
        <Text variant="caption" className="p-sp-5">
          {t("FUNNEL_FOOTER_DISCLAIMER_TEXT")}
        </Text>
      </div>
    </footer>
  );
}
